import { type GeoImage, type Stored } from "@overmap-ai/common"
import { selectGeoImages } from "@overmap-ai/core"
import { ReactRenderer } from "@tiptap/react"

import { appStore } from "../../../../store"
import type { MentionListRootProps } from "../../../blocks/MentionList/Root"
import type { MentionListRef } from "../../../blocks/MentionList/typings"
import { GeoImageMentionList } from "../../../components/MentionLists"
import type { SuggestionOptions } from "../typings"
import { updatePosition } from "../utils"

export const suggestion: SuggestionOptions<Stored<GeoImage>> = {
	char: "@g",
	items: ({ query }) => {
		const geoImages = selectGeoImages(appStore.getState())

		return geoImages
			.filter((geoImage) => {
				const searchText = geoImage.title || geoImage.file_name || "Untitled image"
				return searchText.toLowerCase().startsWith(query.toLowerCase())
			})
			.slice(0, 10)
	},

	render: () => {
		let component: ReactRenderer<MentionListRef<Stored<GeoImage>>, MentionListRootProps<Stored<GeoImage>>>

		return {
			onStart: (props) => {
				component = new ReactRenderer(GeoImageMentionList, {
					props,
					editor: props.editor,
					as: "div",
				})

				if (!props.clientRect) {
					return
				}

				;(component.element as HTMLElement).style.position = "fixed"
				component.element.setAttribute("data-floating-content", "")

				document.body.appendChild(component.element)

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onUpdate(props) {
				component.updateProps(props)

				if (!props.clientRect) {
					return
				}

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onKeyDown(props) {
				if (props.event.key === "Escape") {
					component.destroy()

					return true
				}

				return component.ref?.onKeyDown?.(props) ?? false
			},

			onExit() {
				component.element.remove()
				component.destroy()
			},
		}
	},
}
